import hexagonUrl from '../assets/images/hexagon.svg?url'
import hexDarkUrl from '../assets/images/hex-dark.webp?url'
import hexWhiteUrl from '../assets/images/hex-white.webp?url'
import hexBlueUrl from '../assets/images/hex-blue.webp?url'
import hexOrangeUrl from '../assets/images/hex-orange.webp?url'
import hexGreenUrl from '../assets/images/hex-green.webp?url'
import hexDiamondUrl from '../assets/images/hex-diamond.webp?url'

const IMAGE_ASSETS = {
	hexagon: hexagonUrl,
	hexDark: hexDarkUrl,
	hexWhite: hexWhiteUrl,
	hexBlue: hexBlueUrl,
	hexOrange: hexOrangeUrl,
	hexGreen: hexGreenUrl,
	hexDiamond: hexDiamondUrl,
} as const

type SlideImageAssetKey = keyof typeof IMAGE_ASSETS

const TIER_IMAGE_KEY = {
	dark: 'hexDark',
	white: 'hexWhite',
	blue: 'hexBlue',
	orange: 'hexOrange',
	green: 'hexGreen',
	diamond: 'hexDiamond',
} as const

export class AssetManager {
	private static loaded = false
	private static readonly imageElements = new Map<SlideImageAssetKey, HTMLImageElement>()

	static getImageUrl(key: SlideImageAssetKey): string {
		return IMAGE_ASSETS[key]
	}

	static getImageElement(key: SlideImageAssetKey): HTMLImageElement | null {
		return this.imageElements.get(key) ?? null
	}

	static getTierImage(tier: keyof typeof TIER_IMAGE_KEY): HTMLImageElement | null {
		return this.getImageElement(TIER_IMAGE_KEY[tier])
	}

	static isLoaded(): boolean {
		return this.loaded
	}

	static async loadAll(onProgress?: (progress: number) => void): Promise<void> {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		const imageKeys = Object.keys(IMAGE_ASSETS) as SlideImageAssetKey[]
		const total = imageKeys.length
		let completed = 0

		const markProgress = () => {
			completed += 1
			onProgress?.(completed / total)
		}

		await Promise.all(
			imageKeys.map(
				(key) =>
					new Promise<void>((resolve) => {
						const image = new Image()
						image.onload = () => {
							this.imageElements.set(key, image)
							markProgress()
							resolve()
						}
						image.onerror = () => {
							markProgress()
							resolve()
						}
						image.src = IMAGE_ASSETS[key]
					}),
			),
		)

		this.loaded = true
		onProgress?.(1)
	}
}
